import { render, staticRenderFns } from "./TableRows.vue?vue&type=template&id=36a8cfd2"
import script from "./TableRows.vue?vue&type=script&lang=js"
export * from "./TableRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports